import { Component } from '@angular/core';
import { ApiResponse } from '@hutsix/ngxh6';
import { environment } from '../../../../../../environments/environment';
import { PermitViewGrantService } from '../../../services/permit-view-grant.service';

interface TouristPassResult {
    /** TLC's per-type 'what happens next' line, shown on the confirmation screen. */
    submitMessage?: string | null;
    viewGrant?: string;
    viewGrantExpiresAt?: number;
    permitType: string;
    permitNumber: string;
    status: string;
    /** Shown on the confirmation so the applicant can see where it went. */
    email?: string | null;
    partySize?: number;
    token: string;
    magicLinkPath: string;
    pdfPath: string;
    /** Download path for the tourist locations map, present only when TLC have published one. */
    mapPath?: string | null;
    accessStartDate: string;
    accessEndDate: string;
}

/**
 * Tourist Pass application. The form is defined server-side in
 * App\Form\Permit\TouristPassType (marked `public` via #[Form]) and rendered by
 * the standard <ngxh6-form-embed>, which loads the schema and submits it as a
 * guest (skipAuth + bypassOfflineQueue) with no bespoke fetch code here.
 */
@Component({
    selector: 'app-apply-tourist-pass',
    templateUrl: './apply-tourist-pass.component.html',
    styleUrls: ['./apply-tourist-pass.component.scss'],
    standalone: false,
})
export class ApplyTouristPassComponent {
    public result?: TouristPassResult | null;

    constructor(private grants: PermitViewGrantService) {}

    public get pdfUrl(): string | null {
        return this.result ? `${environment.apiUrl}/api/public/permit/${this.result.token}/pdf` : null;
    }

    /**
     * The tourist locations map download, or null when TLC haven't published one (the
     * backend only sets mapPath for Tourist permits when a map exists, so the button
     * never points at a 404).
     */
    public get mapUrl(): string | null {
        return this.result?.mapPath ? `${environment.apiUrl}${this.result.mapPath}` : null;
    }

    public onSubmitted(res: ApiResponse<TouristPassResult>): void {
        // Only switch to the success panel on a real success (a permit was created).
        // A validation error must leave the form in place so its errors show.
        if (res?.data?.status) {
            this.result = res.data;
            // They just gave us this email on the form - don't re-ask on the next click.
            this.grants.remember(res.data);
        }
    }
}
